/* RESPONSIBLE TEAM: team-channels */

/**
 * Utility function to check if the fin email sender settings feature is enabled.
 * This feature allows Fin to use custom email addresses for sending replies.
 *
 * The feature is enabled when:
 * - The main feature flag 'team-channels-fin-email-sender-settings' is enabled
 * - AND the opt-out flag 'team-channels-fin-email-sender-settings-opt-out' is NOT enabled
 *
 */
export function canUseFinEmailSenderSettings(app: any): boolean {
  return (
    app.canUseFeature('team-channels-fin-email-sender-settings') &&
    !app.canUseFeature('team-channels-fin-email-sender-settings-opt-out')
  );
}
